import React from "react";
import { Navigate } from "react-router-dom";

export default function PublicRoute({ component: Component, ...rest }) {
  const isAuthenticated = sessionStorage.getItem("token");

  if (!!isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  return <Component {...rest} />;
}
